"use strict";

function ownKeys(a, b) {
  var c = Object.keys(a);

  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }

  return c;
}

function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) {
    b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
      _defineProperty(a, c, b[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
      Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
    });
  }

  return a;
}

function _defineProperty(a, b, c) {
  return b in a ? Object.defineProperty(a, b, {
    value: c,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : a[b] = c, a;
}

function _toConsumableArray(a) {
  return _arrayWithoutHoles(a) || _iterableToArray(a) || _unsupportedIterableToArray(a) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _iterableToArray(a) {
  if ("undefined" != typeof Symbol && Symbol.iterator in Object(a)) return Array.from(a);
}

function _arrayWithoutHoles(a) {
  if (Array.isArray(a)) return _arrayLikeToArray(a);
}

function _slicedToArray(a, b) {
  return _arrayWithHoles(a) || _iterableToArrayLimit(a, b) || _unsupportedIterableToArray(a, b) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(a, b) {
  if (a) {
    if ("string" == typeof a) return _arrayLikeToArray(a, b);
    var c = Object.prototype.toString.call(a).slice(8, -1);
    return "Object" === c && a.constructor && (c = a.constructor.name), "Map" === c || "Set" === c ? Array.from(a) : "Arguments" === c || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(c) ? _arrayLikeToArray(a, b) : void 0;
  }
}

function _arrayLikeToArray(a, b) {
  (null == b || b > a.length) && (b = a.length);

  for (var c = 0, d = Array(b); c < b; c++) {
    d[c] = a[c];
  }

  return d;
}

function _iterableToArrayLimit(a, b) {
  if ("undefined" != typeof Symbol && Symbol.iterator in Object(a)) {
    var c = [],
        d = !0,
        e = !1,
        f = void 0;

    try {
      for (var g, h = a[Symbol.iterator](); !(d = (g = h.next()).done) && (c.push(g.value), !(b && c.length === b)); d = !0) {
        ;
      }
    } catch (a) {
      e = !0, f = a;
    } finally {
      try {
        d || null == h["return"] || h["return"]();
      } finally {
        if (e) throw f;
      }
    }

    return c;
  }
}

function _arrayWithHoles(a) {
  if (Array.isArray(a)) return a;
}

function _typeof(a) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (a) {
    return typeof a;
  } : function (a) {
    return a && "function" == typeof Symbol && a.constructor === Symbol && a !== Symbol.prototype ? "symbol" : typeof a;
  }, _typeof(a);
}

(function (a, b) {
  "object" === ("undefined" == typeof exports ? "undefined" : _typeof(exports)) && "undefined" != typeof module ? module.exports = b() : "function" == typeof define && define.amd ? define(b) : (a = a || self, a.fluidSystem = b());
})(void 0, function () {
  'use strict';

  var a = function a(_a, b) {
    return function () {
      return b(_a.apply(void 0, arguments));
    };
  },
      b = function b() {
    for (var b = arguments.length, c = Array(b), d = 0; d < b; d++) {
      c[d] = arguments[d];
    }

    return c.reduce(a);
  },
      c = function c(a) {
    return !isNaN(parseInt(a));
  },
      d = function d(a) {
    if (!a) return null;
    if ("number" == typeof a) return "px";
    var b = a.match(/^([+-]?(?:\d+|\d*\.\d+))([a-z]*|%)$/);
    return b ? b[2] : null;
  },
      e = function e(a) {
    return parseFloat(a);
  },
      f = function f(a) {
    return "@media screen and (min-width: ".concat(a, ")");
  },
      g = function g(a) {
    var b = _slicedToArray(a, 2),
        c = b[0],
        d = b[1];

    return d.theme.breakpoints || (d.theme.breakpoints = ["40em", "52em", "64em"]), [c, d];
  },
      h = function h(a) {
    var b = _slicedToArray(a, 2),
        c = b[0],
        d = b[1],
        f = d.theme.breakpoints;

    if (f.constructor === Object) {
      var g = Object.entries(f).filter(function (a) {
        var b = _slicedToArray(a, 1),
            c = b[0];

        return "fluidStart" !== c;
      }).map(function (a) {
        var b = _slicedToArray(a, 2),
            c = b[1];

        return c;
      }).sort(function (c, a) {
        return e(c) - e(a);
      }),
          h = f.fluidStart;
      d.theme.breakpoints = g, d.theme.breakpoints.fluidStart = h;
    }

    return [c, d];
  },
      i = function i(a) {
    var b = _slicedToArray(a, 2),
        c = b[0],
        e = b[1],
        f = e.theme.breakpoints,
        g = f.map(d);

    if (1 < new Set(g).size) throw new TypeError("Cannot interpolate between dissimilar units in the theme breakpoints: [".concat(f.map(function (a) {
      return "\"".concat(a, "\"");
    }).join(", "), "]"));
    return [c, e];
  },
      j = function j(a) {
    var b = _slicedToArray(a, 2),
        c = b[0],
        e = b[1];

    if (!e.theme.breakpoints.fluidStart) {
      var f = d(e.theme.breakpoints[0]);

      switch (f) {
        case "em":
          e.theme.breakpoints.fluidStart = "20em";
          break;

        case "rem":
          e.theme.breakpoints.fluidStart = "20rem";
          break;

        case "px":
          e.theme.breakpoints.fluidStart = "320px";
          break;

        default:
          throw new TypeError("Cannot define a default fluid starting width for \"".concat(f, "\" unit breakpoints; manually set the alias on the theme object instead"));
      }
    }

    return [c, e];
  },
      k = function k(a) {
    var b = _slicedToArray(a, 2),
        c = b[0],
        e = b[1],
        f = d(e.theme.breakpoints.fluidStart),
        g = e.theme.breakpoints.length ? d(e.theme.breakpoints[0]) : null;

    if (g && f !== g) throw new TypeError("\"The fluid starting width must be defined in the same unit as the theme breakpoints\"");
    return [c, e];
  },
      l = function l(a) {
    var b = _slicedToArray(a, 2),
        c = b[0],
        f = b[1],
        g = f.theme.breakpoints,
        h = c(f),
        i = m(d(g[0]), h),
        j = [g.fluidStart].concat(_toConsumableArray(g)).sort(function (c, a) {
      return e(c) - e(a);
    });

    j.fluidStart = g.fluidStart;
    var k = n(i, j),
        l = o(k, j),
        p = r(h, l);
    return p;
  },
      m = function m(a, b) {
    var e = Object.entries(b).filter(function (a) {
      var b = _slicedToArray(a, 2),
          d = b[0],
          e = b[1];

      return !d.startsWith("@media") && c(e);
    }).map(function (a) {
      var b = _slicedToArray(a, 1),
          c = b[0];

      return c;
    }),
        f = Object.keys(b).filter(function (a) {
      return a.startsWith("@media");
    }),
        g = e.map(function (a) {
      var c = f.map(function (c) {
        return b[c][a];
      }),
          d = [b[a]].concat(_toConsumableArray(c)).map(function (a) {
        return "number" == typeof a ? a + "px" : a;
      });
      return {
        property: a,
        values: d
      };
    }),
        h = g.filter(function (b) {
      var c = b.values.map(d).filter(Boolean),
          e = 1 === new Set(c).size,
          f = c[0] === a;
      return e && f;
    });
    return h;
  },
      n = function n(a, b) {
    return a.reduce(function (a, c) {
      for (var d = b.findIndex(function (a) {
        return a === b.fluidStart;
      }), e = c.values.map(function (a, b) {
        return a === void 0 ? null : b;
      }).filter(Number.isInteger), f = [], g = d; g < e.length - 1; g++) {
        var h = e[g],
            j = e[g + 1];
        f.push({
          values: [c.values[h], c.values[j]],
          breakpoints: [b[h], b[j]]
        });
      }

      return _objectSpread(_objectSpread({}, a), {}, _defineProperty({}, c.property, f));
    }, {});
  },
      o = function o(a, b) {
    var c = Object.entries(a).map(function (a) {
      var b = _slicedToArray(a, 2),
          c = b[0],
          d = b[1];

      return p(c, d);
    }),
        d = b.map(function (a) {
      return f(a);
    }),
        e = d.reduce(function (a, b) {
      return _objectSpread(_objectSpread({}, a), {}, _defineProperty({}, b, c.map(function (a) {
        return a[b];
      }).reduce(function (a, b) {
        return _objectSpread(_objectSpread({}, a), b);
      }, {})));
    }, {});
    return e;
  },
      p = function p(a, b) {
    return b.reduce(function (b, c) {
      var d = _slicedToArray(c.values, 2),
          e = d[0],
          g = d[1],
          h = _slicedToArray(c.breakpoints, 2),
          i = h[0],
          j = h[1];

      return _objectSpread(_objectSpread({}, b), {}, _defineProperty({}, f(i), _defineProperty({}, a, q([e, g], [i, j]))));
    }, {});
  },
      q = function q(a, b) {
    var c = _slicedToArray(a, 2),
        d = c[0],
        f = c[1],
        g = _slicedToArray(b, 2),
        h = g[0],
        i = g[1];

    return "calc(".concat(d, " + (").concat(e(f), " - ").concat(e(d), ")*(100vw - ").concat(h, ")/(").concat(e(i), " - ").concat(e(h), "))");
  },
      r = function r(a, b) {
    var c = Object.keys(a).filter(function (a) {
      return !a.startsWith("@media");
    }).reduce(function (b, c) {
      return _objectSpread(_objectSpread({}, b), {}, _defineProperty({}, c, a[c]));
    }, {}),
        d = [].concat(_toConsumableArray(Object.keys(a)), _toConsumableArray(Object.keys(b))).filter(function (a) {
      return a.startsWith("@media");
    }).filter(function (a, b, c) {
      return c.indexOf(a) === b;
    }),
        e = d.sort(function (c, a) {
      return parseFloat(c.match(/@media screen and \(min-width: (.*)\)/)[1]) - parseFloat(a.match(/@media screen and \(min-width: (.*)\)/)[1]);
    }),
        f = e.reduce(function (c, d) {
      var e = _objectSpread(_objectSpread({}, a[d]), b[d]);

      return Object.entries(e).length ? _objectSpread(_objectSpread({}, c), {}, _defineProperty({}, d, e)) : c;
    }, _objectSpread({}, c));
    return f;
  };

  return function fluid(a) {
    return b(function (b) {
      return [a, b];
    }, g, h, i, j, k, l);
  };
});